"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParcelPreview = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _parcelPreview = require("./parcelPreview.style");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = require("../../svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ParcelPreview = function ParcelPreview(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _parcelPreview.useStyles)(props);
  var _props$dimensions = props.dimensions,
      z = _props$dimensions.z,
      x = _props$dimensions.x,
      y = _props$dimensions.y;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.box)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.boxIcon)
  }, _svg.box), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.lengthArrow, " ").concat(classes.arrow)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.lengthArrowIcon)
  }, props.white ? _svg.arrowIconWhite : _svg.arrowIcon), /*#__PURE__*/_react["default"].createElement("p", null, z)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.widthArrow, " ").concat(classes.arrow)
  }, /*#__PURE__*/_react["default"].createElement("p", null, x), /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.widthArrowIcon)
  }, props.white ? _svg.arrowIconWhite : _svg.arrowIcon)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.heightArrow, " ").concat(classes.arrow)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.heightArrowIcon)
  }, props.white ? _svg.arrowIconWhite : _svg.arrowIcon), /*#__PURE__*/_react["default"].createElement("p", null, y)));
};

exports.ParcelPreview = ParcelPreview;
ParcelPreview.propTypes = {
  /** ParcelPreview  dimensions */
  dimensions: _propTypes["default"].object
};